import { Link } from "react-router-dom";
import BootstrapTable from 'react-bootstrap-table-next';
import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import { deleteContractType } from '../../../../services/RHService/ContractTypeService';
import { updateContractType } from '../../../../services/RHService/ContractTypeService';
import { getContractTypes } from '../../../../services/RHService/ContractTypeService';
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";
import withLoader from "../../../../components/layouts/WithLoader";
const ContractTypeList = ({ startLoading, stopLoading }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const [data,] = useState([]);
    const [selectedContract, setSelectedContract] = useState(null);
    const [contracttypes, setContracttypes] = useState([]);
    const [idContrat, setIdContrat] = useState("");
    const [nomContrat, setNomContrat] = useState("");
    const [duree, setDuree] = useState("");
    const handleShow = (Contract) => {
        setNomContrat(Contract.nomContrat);
        setDuree(Contract.duree);
        setIdContrat(Contract.id);
        setSelectedContract(Contract);
        setShow(true);
    };

    //afficher dans le tableau
    useEffect(() => {
        fetchData();
    }, []);
    const fetchData = async () => {
        startLoading();
        getContractTypes(getCurrentUserId()).then((response) => {
            if (response.data.success) {
                setContracttypes(response.data.success);
            } else {
                setContracttypes([])
            }
        }).catch((e) => {
            console.log(e)

        }).finally(() => {
            stopLoading();
        })

    };
    //update contract type
    const handleUpdate = (event) => {
        try {

            let formData = {
                idUser: getCurrentUserId(),
                nomContrat: nomContrat,
                duree: duree,
                idContrat: idContrat,
            }

            updateContractType(formData).then((response) => {
                fetchData();
                handleClose();
            }).catch((e) => {
                console.log(e)
            })

        } catch (error) {
            alert(error.message);
        }

    };
    //archiver type de contrat
    const handleDelete = async (contracttypeID) => {
        await deleteContractType(contracttypeID, setContracttypes);
    };
    const options = {
        sizePerPage: 5,
        hideSizePerPage: true,
        hidePageListOnlyOnePage: true,
        paginationPosition: "bottom",
    };
    const columns = [
        // {
        //     dataField: 'id', text: '#', formatter: (cell, row, rowIndex, formatExtraData) => {
        //         return rowIndex + 1;
        //     }
        // },
        { dataField: 'nomContrat', text: 'Contrat' },
        { dataField: 'duree', text: 'Durée' },
        {
            dataField: 'actions', text: 'Actions', formatter: (cell, row) => {
                return (
                    <ul class="nav nav-pills ml-auto">
                        <li class="nav-item dropdown" >
                            <div class="nav-link " data-toggle="dropdown" href="#">
                                <i class="fa-solid fa-ellipsis-vertical"></i>
                            </div>
                            <div class="dropdown-menu" >
                                <Button style={{ "background-color": "white", "color": "black", "border-color": "transparent" }} onClick={() => { handleShow(row) }}>
                                    <i class="fa-solid fa-pen m-2" ></i>Edit
                                </Button>
                                <Button style={{ "background-color": "white", "color": "black", "border-color": "transparent" }} onClick={() => { handleDelete(row.id) }}>
                                    <i class="fa-solid fa-trash m-2"></i>Remove
                                </Button>
                            </div>
                        </li>
                    </ul>
                );
            }
        }
    ];

    const onChangeNameContratHandler = (event) => {
        setNomContrat(event.target.value);
    };
    const onChangeDureeHandler = (event) => {
        setDuree(event.target.value);
    };

    return (
        <div className="content-wrapper" style={{ marginTop: "0" }}>
            <ToolkitProvider
                keyField="id"
                data={data}
                columns={columns}
                exportCSV={{ onlyExportFiltered: true, exportAll: false }}
                search
            >
                {
                    props => (
                        <div>
                            <Modal show={show} onHide={handleClose} size="lg">
                                <Modal.Header closeButton>
                                    <Modal.Title>Modifier les informations</Modal.Title>
                                </Modal.Header>
                                <Modal.Body className="show-grid">
                                    <Form onSubmit={handleUpdate}>
                                        <Container>
                                            <Row>
                                                <Col xs={12} md={6} >
                                                    <div className="form-group">
                                                        <label htmlFor="inputName">Contrat</label>
                                                        <input
                                                            // placeholder="Ajouter libellé "
                                                            onChange={onChangeNameContratHandler}
                                                            type="text"
                                                            id="inputName"
                                                            value={nomContrat}
                                                            className="form-control"
                                                        />                                                  </div>
                                                    <div className="form-group">
                                                        <label htmlFor="inputName">Durée</label>
                                                        <input
                                                            // placeholder="Ajouter libellé "
                                                            onChange={onChangeDureeHandler}
                                                            value={duree}
                                                            type="text"
                                                            id="inputName"
                                                            className="form-control"
                                                        />                                                    </div>
                                                </Col>

                                            </Row>
                                        </Container>
                                    </Form>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleClose}>
                                        Fermer
                                    </Button>
                                    <Button variant="dark" onClick={handleUpdate}>
                                        Modifier
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                            <div className="content-header">
                                <div className="container-fluid">
                                    <div className="row mb-2">
                                        <div className="col-sm-6">
                                            <h1 className="m-0">Liste des types de contrat</h1>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div class="container-fluid">
                                <div class="card card-dark">
                                    <div class="card-body">
                                        <h5 class="card-title">Ajouter un type de contrat</h5>

                                        <Link to="/addcontracttype" >
                                            <button
                                                class="btn btn-dark float-right"
                                            >
                                                {" "}
                                                <i class="fas fa-plus"></i>
                                            </button>
                                        </Link>


                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12">
                                        <div class="card">
                                            <div class="card-header">
                                                <h3 class="card-title">Liste des types de contrat</h3>
                                            </div>
                                            <BootstrapTable keyField='id' data={contracttypes} columns={columns} pagination={paginationFactory(options)} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
            </ToolkitProvider>
        </div>
    );
}

export default withLoader(ContractTypeList);